import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { UserFacadeService } from "../facades/userfacade/userfacade.service";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";

export const authGuard = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const oidcSecurityService = inject(OidcSecurityService);
  const userFacadeService = inject(UserFacadeService);

  if (!oidcSecurityService.isAuthenticated()) {
    return router.parseUrl("/home");
  }

  if (route.data.roles) {
    try {
      const res = await firstValueFrom(userFacadeService.getUserRolesandPermissions());
      if (route.data.roles.indexOf(res.value.toString()) === -1) {
        // not authorised, redirect to home
        return router.parseUrl("/home");
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  return true;
};
